export const MENU_BUTTON_TEST_ID = {
  button: 'menu-button',
};
